import React from 'react';

import { ParallaxBanner } from "react-scroll-parallax";

import profileWebp from '../../resources/profile.png.webp';
import profilePng from '../../resources/profile.png';
import { useIsMobile } from '../../hooks/useIsMobile'; // Import the hook
import { usePrefersDarkMode } from '../../hooks/usePrefersDarkMode';
import './herosection.css';

function HeroSection() {
    const isMobile = useIsMobile(); // Use the hook
    const prefersDarkMode = usePrefersDarkMode();

    const getBackgroundImage = () => {
        if (prefersDarkMode) {
            return isMobile ? '/backgrounds/ord-tunnel.avif' : '/backgrounds/williamsburg.avif';
        }
        return isMobile ? '/backgrounds/brooklyn_bridge-mobile.avif' : '/backgrounds/iceland-background.avif';
    };

    const backgroundImage = getBackgroundImage();

    return (
      <ParallaxBanner
        layers={[{ image: backgroundImage, speed: -20 }]} // Use the selected image
        className="hero-banner hdr-limit-light"
      >
        <div className="hero-overlay">
          <div className="profileCaption">
              <picture>
                  <source type="image/webp" srcSet={profileWebp} />
                  <img
                    src={profilePng}
                    alt="Profile of Matt Geimer"
                    className="hero-profile-img"
                  />
              </picture>
          </div>
        </div>
      </ParallaxBanner>
    );
  }
export default HeroSection;